@if ((hideGamingCrossSellByArc$ | async) === false) {
    <ds-card surface="lowest" [radius]="true" [inverse]="true" [border]="false" [elevated]="true">
        <a class="jackpot-banner-content" [attr.target]="model.link?.target" (click)="onJackpotBannerClick()">
            @if (model.background) {
                <img class="banner-background-image" fill [ngSrc]="model.background" [priority]="listIndex === 0" />
            }
            <div class="banner-info">
                <div class="banner-title">{{ model.title }}</div>
                <div class="banner-subtitle">{{ model.subtitle }}</div>
                <div class="banner-ticker">
                    @for (character of characters; track $index) {
                        <div [ngClass]="{ 'banner-tick-currency': character.isCurrency, 'banner-tick-separator': character.isSeparator }">
                            @if (character.isCurrency) {
                                {{ character.currency }}
                            }
                            @if (character.isSeparator) {
                                {{ character.separator }}
                            }
                            @if (character.isDigit) {
                                <ms-banner-tick [model]="character.digit" />
                            }
                        </div>
                    }
                </div>
            </div>
            @if (model.icon) {
                <div class="banner-image"><img width="86" [ngSrc]="model.icon" /></div>
            }
        </a>
    </ds-card>
}
